import { Formik } from 'formik';

import { FormikField } from '@air/formik-field';
import { Button } from '@air/primitive-button';
import { Input } from '@air/primitive-input';

import Form from '~/components/Form';

export type LibraryDeleteConfirmationModalFormProps = {
  name: string;
  isPending: boolean;
  onClose: () => void;
  onSubmit: (values: { name: string }) => void;
};

export const LibraryDeleteConfirmationModalForm = ({
  name,
  isPending,
  onClose,
  onSubmit,
}: LibraryDeleteConfirmationModalFormProps) => {
  return (
    <Formik initialValues={{ name: '' }} onSubmit={onSubmit}>
      {({ values }) => (
        <Form className="mt-4">
          <FormikField
            label={`Type ${name} to confirm`}
            name="name"
            id="name"
            component={<Input size="large" placeholder={name} disabled={isPending} />}
          />

          <div className="mt-6 flex justify-end gap-3">
            <Button appearance="ghost" color="grey" onClick={onClose} size="large" disabled={isPending}>
              Cancel
            </Button>
            <Button
              appearance="filled"
              color="red"
              disabled={values.name !== name}
              isLoading={isPending}
              size="large"
              type="submit"
            >
              Delete
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};
